module.exports = __webpack_public_path__ + "static/media/exactValueTriangle3.5ad488e1.svg";